/* eslint-disable */
/* tslint:disable */

import { WorkerStartMethodDto } from "./data-contracts";

import { Service } from "./Service";

/**
 * @title Spatial Processing Core API
 * @version 1.5.1.0
 * @baseUrl /sp
 */
export class RemoteTaskManagerService extends Service {
  /**
   * No description
   *
   * @tags RemoteTaskManager
   * @name Post
   * @operationId RemoteTaskManagerController_Post
   * @summary Run method by HttpPost.
   * @request POST:/scheduler/worker
   * @response `200` OK
   */
  createWorker(data: WorkerStartMethodDto) {
    return this.http.post(`/scheduler/worker`, data).json<any>();
  }
}
